import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
} from '@material-ui/core';
import InfiniteScroll from 'react-infinite-scroller';
import { getSortArrow, SortState } from '../../utils/sort';
import useStyles from './styles';
import { StyledTableRow, InfiniteTableRow } from './TableRow';
import { TableColumn } from './types';

interface Props<T> {
  containerClass?: string;
  loadMore: () => void;
  hasMore: boolean;
  tableColumns: TableColumn<T>[];
  sortState: SortState<T>;
  data: T[];
  page: number;
  getKeyValue: (entity: T) => string;
  onRowClick?: (entity: T) => void;
  onDoubleClick?: (txt: string) => void;
}

function InfiniteTable<T>(props: Props<T>) {
  const {
    containerClass,
    loadMore,
    hasMore,
    tableColumns,
    sortState,
    data,
    getKeyValue,
    page,
    onRowClick,
    onDoubleClick,
  } = props;
  const classes = useStyles();

  return (
    <div className={containerClass ? containerClass : ''}>
      <InfiniteScroll
        element="div"
        pageStart={page || 0}
        initialLoad={false}
        loadMore={loadMore}
        hasMore={hasMore}
        useWindow={false}
        threshold={270}
      >
        <Paper className={classes.paperRoot}>
          <Table stickyHeader className={classes.table} size="small">
            <colgroup>
              {tableColumns.map((column: any) => (
                <col key={'col-' + column.name} width={column.width} />
              ))}
            </colgroup>
            <TableHead>
              <StyledTableRow>
                {tableColumns.map((column: any) => (
                  <TableCell
                    key={'header-' + column.name}
                    className={column.noPadding ? 'noPadding' : ''}
                  >
                    <div
                      className={classes.sortableCell}
                      onClick={() =>
                        column.onHeaderClick && column.onHeaderClick(column)
                      }
                    >
                      {column.header}

                      {!!column.onHeaderClick
                        ? getSortArrow(column.name, sortState)
                        : null}
                    </div>
                  </TableCell>
                ))}
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {data.map((entity, index) => (
                <InfiniteTableRow
                  key={getKeyValue(entity)}
                  getKeyValue={getKeyValue}
                  entity={entity}
                  tableColumns={tableColumns}
                  onRowClick={onRowClick}
                  onDoubleClick={onDoubleClick}
                />
              ))}
              {hasMore ? (
                <tr className="loadMore">
                  <td
                    colSpan={tableColumns.length}
                    style={{ textAlign: 'center' }}
                  >
                    <Button onClick={loadMore} color="primary" variant="text">
                      Load more
                    </Button>
                  </td>
                </tr>
              ) : null}
            </TableBody>
          </Table>
        </Paper>
      </InfiniteScroll>
    </div>
  );
}

export default InfiniteTable;
